import { StampAnnotation } from '@st/sdk/src/sdk.types'
import { StampToolState } from '~/st-doc-viewer/annotations'
import { findMatchingTemplate } from './templates'

export function syncToolStateWithAnnotation(annotation: StampAnnotation): StampToolState {
  const matchingTemplate = findMatchingTemplate(annotation)

  return {
    name: 'stamp',
    settings: {
      templateId: matchingTemplate?.id,
      stampSize: annotation.stampSize
    }
  }
}
